import { render, staticRenderFns } from "./TableStatistics.vue?vue&type=template&id=660712e4&scoped=true"
import script from "./TableStatistics.vue?vue&type=script&lang=js"
export * from "./TableStatistics.vue?vue&type=script&lang=js"
import style0 from "./TableStatistics.vue?vue&type=style&index=0&id=660712e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660712e4",
  null
  
)

export default component.exports